import styled from 'styled-components';
import { getSpacing, fontSize } from 'stylesheetB2b';

export const Container = styled.div`
`;

export const SliderContainer = styled.div`
display: flex;
flex-direction: column;
align-items: center;
background-color: #010101;
width: 200px;
border: 1px solid rgb(28 24 24);
box-shadow: 0 0 10 0 rgba(0 0 0 / 75%);
font-family: 'Open Sans', sans-serif;
`;

export const Title = styled.h3`
color: white;
font-size: ${fontSize.small};
font-weight: bold;
margin: ${getSpacing(2)};
`;

export const SliderIndicator = styled.div`
color: white;
font-size: ${fontSize.extraExtraSmall};
margin: ${getSpacing(3)} 0;
font-weight: 400;
`;

export const SliderIndicatorContainer = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
`;

export const ResetButton = styled.button<{ color: string }>`
background: white;
background-color: ${({ color }) => color};
border-radius: 5px;
margin: 0;
margin-bottom: 10px;
margin-right: 10px;
height: 20px;
width: 30px;
padding: 0;

:hover {
    background-color: ${({ color }) => color};
}
`;
